function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState, useRef, forwardRef } from 'react';
import DropDownIcon from '@material-ui/icons/ArrowDropDown';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  root: {
    fontFamily: "Akkurat, sans-serif",
    fontWeight: "bold",
    textTransform: "none",
    borderRadius: 1
  },
  icon: {
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(-.5)
  },
  toggle: {
    borderRadius: 0,
    width: theme.spacing(5)
  }
}));

const ActionButton = (_ref) => {
  let className = _ref.className,
      forwardedRef = _ref.forwardedRef,
      icon = _ref.icon,
      role = _ref.role,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "contained" : _ref$variant,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      disabled = _ref.disabled,
      expanded = _ref.expanded,
      controls = _ref.controls,
      children = _ref.children,
      onClick = _ref.onClick,
      onToggle = _ref.onToggle,
      item = _objectWithoutPropertiesLoose(_ref, ["className", "forwardedRef", "icon", "role", "size", "variant", "color", "disabled", "expanded", "controls", "children", "onClick", "onToggle"]);

  const label = item.label,
        title = item.title;
  const classes = useStyles();

  if (onClick && onToggle) {
    return React.createElement(ButtonGroup, {
      "aria-label": "action",
      color: color,
      ref: forwardedRef
    }, React.createElement(Button, {
      size: size,
      variant: variant,
      className: className || classes.root,
      disabled: disabled,
      onClick: onClick
    }, icon && React.createElement(Icon, {
      className: classes.icon
    }, icon), label || title), React.createElement(Button, {
      size: size,
      variant: variant,
      className: classes.toggle,
      size: "small",
      "aria-controls": expanded ? controls : undefined,
      "aria-expanded": expanded ? 'true' : undefined,
      "aria-label": "options",
      "aria-haspopup": "menu",
      onClick: onToggle
    }, React.createElement(DropDownIcon, null)));
  }

  if (onToggle) {
    return React.createElement(Button, {
      size: size,
      variant: variant,
      color: color,
      className: className || classes.root,
      disabled: disabled,
      onClick: onToggle,
      ref: forwardedRef
    }, icon && React.createElement(Icon, {
      className: classes.icon
    }, icon), label || title, React.createElement(DropDownIcon, null));
  }

  return React.createElement(Button, {
    size: size,
    variant: variant,
    color: color,
    className: className || classes.root,
    disabled: disabled,
    onClick: onClick
  }, icon && React.createElement(Icon, {
    className: classes.icon
  }, icon), label || title);
};

export default ActionButton;